import { EChartOption, EChartsSeriesType } from "echarts";
import ReactECharts from "echarts-for-react";

export type TDataType = {
    [key: string]: string | number;
};
export type TChartData = {
    type: EChartsSeriesType;
    lineStyleColor: string;
    areaStyleColor: string;
    data: Array<TDataType>;
};
export interface IChart {
    data?: Array<TChartData>;
    legend?: Array<string>;
    title?: string;
    yAxisFormatter?(value: number): string;
}

const MultiLinesChart = (props: IChart) => {
    const { data, title, legend, yAxisFormatter } = props;
    const series: EChartOption.Series[] = [];
    data?.forEach((el, index) => {
        series.push({
            data: Object.values(el.data || {}),
            name: legend ? legend[index] : undefined,
            type: el.type,
            silent: true,
            smooth: true,
            symbol: "none",
            areaStyle: el.areaStyleColor ? { color: el.areaStyleColor, opacity: 1 } : undefined,
            lineStyle: { color: el.lineStyleColor },
            itemStyle: { color: el.lineStyleColor },
        });
    });
    const options: EChartOption = {
        title: {
            text: title,
        },
        tooltip: {
            trigger: "axis",
        },
        legend: { icon: "roundRect" },
        grid: { left: 20, right: 5 },
        xAxis: {
            type: "category",
            boundaryGap: false,
            splitArea: {
                show: true,
            },
            data: Object.keys(data && data.length > 0 ? data[0].data : {}) || undefined,
            axisLabel: {
                rotate: 90,
            },
        },
        yAxis: {
            type: "value",
            scale: true,
            axisLabel: {
                formatter: yAxisFormatter,
            },
        },

        series,
    };
    return <ReactECharts option={options} />;
};

export default MultiLinesChart;
